<template>
  <v-layout  wrap row justify-center align-center class="contenidoCurso">
    <v-flex xs11 sm10 lg10 >
          <v-layout wrap row justify-center align-center text-center class="animated fadeInDown dura-2">
            <v-flex xs12 sm12 md9 lg6 class="first-cont">
              <h1 class="tittle-big">
                <span class="tittle-small">Ruta de aprendizaje</span>
              </h1>
              <h1 class="tittle-big">
                Gestión de <span class="title-big-sub">crisis</span> y <br><span class="title-big-sub">continuidad del negocio</span>
              </h1>
            </v-flex>
          </v-layout>
          <v-layout wrap row justify-center align-center text-center class="">
            <v-flex xs11 sm12 md6 lg6 mt-1 class="animated bounceIn dura-3 portada-linea">
              <img :src="require('../assets/presentacion/linea.png')" alt="">
            </v-flex>
          </v-layout>
          <v-layout wrap row justify-center align-center text-center class="">
            <v-flex xs12 sm8 md6 lg4 mt-2 class="first-cont  animated dura-3 bounceIn">
              <p class="portada-mensaje">
                Las dificultades preparan a personas comunes para destinos extraordinarios.
              </p>
              <p class="portada-autor">
                C.S Lewis
              </p>
            </v-flex>
          </v-layout>
          <v-layout wrap row justify-center align-center text-xs-center>
            <v-flex xs2 sm2 md2 py-2 px-3 d-flex justify-center align-center class="subtitle-container">
              <div class="cont-bt">
                <router-link
                    to="/ruta/0"
                  >
                  <button class="btn-portada mt-1 animated fadeInUp dura-2" @click="avanzar()">
                    <span>Iniciar</span>
                  </button> 
                </router-link>
              </div>
            </v-flex>      
          </v-layout>
          <v-layout wrap row mt-3 justify-center align-center class="portada-logo-montanas">
            <v-flex xs12>
              <img class="img-logo animated fadeInUp dura-3" :src="require('@/assets/presentacion/montanas.png')" alt="">
            </v-flex>
          </v-layout>
          <v-layout wrap row mt-3 justify-center align-center class="portada-logo-estructura">
            <v-flex xs8 sm5 md4 lg3>
              <img class="img-logo animated fadeInUp dura-2" :src="require('@/assets/presentacion/estructuras.png')" alt="">
            </v-flex>
          </v-layout>
          <v-layout wrap row mt-3 justify-center align-center class="portada-logo-ecopetrol">
            <v-flex xs7 sm3 md3 lg2 class="subportada-logo-ecopetrol">
              <img class="img-logo animated fadeInUp" :src="require('@/assets/imagenes_compartidas/logo.png')" alt="">
            </v-flex>
          </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import nextConditions from "../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      btnColors:['#65B8FF','#2199FF','#0077DC','#005297'],
      iconActive: [true,false,false,false],
      unidadNumber: 1,
    }
  },
  methods:{
    avanzar(){
      this.$store.commit("temaName", 'Objetivos')
      this.$store.commit("subTemaName", 'Objetivos')
    }
  }
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../sass/globals';

h1{
  border-bottom: 0px solid transparent;
  border-image: none;
  font-family: FontBase-Bold;
  font-size: 0rem;
  margin-bottom: 0px;
  text-align: center;
}

.tittle-big{
  font-size:3.5rem;
  text-align: left;
  line-height: 1.1em;
  font-family: FontBase-Regular;
  color:$color-inverted;
  text-align: center;
  .title-big-sub{
  font-family: FontBase-SemiBold;
  }
}
.tittle-small{
  text-align: left;
  font-size:3.2rem;
  color: $color-inverted;
  font-family: FontBase-LightItalic;
  text-align: center;
}
.btn-portada{
  background: #03476b6b;
  margin-top: 20px;
  font-family: FontBase-Regular;
  color: $color-inverted;
  font-size:2rem;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: 3px solid $color-complement-two;
  border-radius: 10px;
}
.btn-portada:hover{  
    color: $color-complement-one;
    border: 3px solid $color-complement-one;
}
.subtitle-container{
    z-index: 100;
}
.contenidoCurso{
  /*background: url('../assets/presentacion/fondo2.png')50%;
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: 100%;*/
  margin-top: -10%;
  height: 105vh;
  //width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.contenidoCurso{
  background: rgb(4,49,91);
  background: linear-gradient(0deg, rgba(4,49,91,1) 15%, rgba(3,93,123,1) 47%, rgba(3,114,139,1) 100%); 
}
.header-intro{
  position: inherit;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0;
}
.portada-contenedor-fondo{
  display: flex;
  justify-content: center;

}
.portada-linea{
  height: 10px;
}
.portada-mensaje,.portada-autor{
  color:#fff;
  text-align: center;
  font-family: FontBase-Italic;
  font-size: 1.5rem;
}
.portada-autor{
  text-align: end;
}
.contenedor-logo{
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
      z-index: 2;
  }

.portada-logo-montanas{
  position: absolute;
  width: 100%;
  bottom: 85px;
  left: 0;
  z-index: 0;
  img.img-logo{
      padding: 0px;
  }
}
.portada-logo-estructura{
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 1;
  img.img-logo{
      padding: 30px;
  }
}
.portada-logo-ecopetrol{
  position: absolute;
  width: 100%;
  height: auto;
  bottom: 0;
  left: 0;
  z-index: 2;
  background: #fff;
  position: fixed;
  bottom: 0px;  
  img.img-logo{
      padding: 10px;
      
  }
}
.subportada-logo-ecopetrol{
  display: flex;
  justify-content: center;
}
@media (max-width: 400px) { .tittle-big{
  font-size:2.2rem;
  }
  .tittle-small{
    font-size:2.2rem;
  }
  .portada-mensaje,.portada-autor{
    font-size: 1.2rem;
  }
  .portada-logo-ecopetrol{
    display: flex;
    justify-content: center;
    img{
      width: 80%;
    }
  }
  .portada-logo-montanas{
    bottom: 40px;
    width: 250%;
  }
  .contenidoCurso{
    height: 100vh;
  }
}
@media (min-width: 400px) and (max-width: 600px) {
  .tittle-big{
  font-size:2rem;
  }
  .tittle-small{
    font-size:2rem;
  }
  .portada-mensaje,.portada-autor{
    font-size: 1.2rem;
  }
  .portada-logo-montanas{
    bottom: 45px;
    width: 250%;
  }
  .portada-logo-ecopetrol{
    display: flex;
    justify-content: center;
    img{
      width: 50%;
      justify-content: center;
    }
  }
  .contenidoCurso{
    margin-top: -15%;
    overflow: hidden;
    height: 100vh;
  }
  .portada-logo-estructura{
    bottom: 0px;
    img.img-logo{
        padding-bottom: 0px;
    }
  }
}
@media (min-width: 600px) and (max-width: 960px) { 
  .portada-logo-montanas{
    bottom: 55px;
    width: 150%;
  }
  .portada-logo-estructura{
    bottom: 20px;
    img.img-logo{
        padding-bottom: 0px;
    }
  }
}
@media (min-width: 960px) and (max-width: 1264px) {
  .portada-logo-montanas{
    bottom: 45px;
    width: 150%;
  }
}
@media (min-width: 1264px) and (max-width: 1704px) {
  .portada-logo-montanas{
    bottom: 45px;
    width: 100%;
  }
}
</style>
